import triplePlayProvvalueerOptions from '../../content/triplePlayProviderOptions';

const productTypeComponent = {
  type: 'Div',
  props: {
    variant: 'widget',
  },
  _children: [
    {
      type: 'Div',
      props: {
        mt: 6,
      },
      _children: [
        {
          type: 'FormComponent',
          props: {
            name: 'productTypes',
            component: {
              type: 'ContentTypeCheckbox',
              props: {
                label: 'Stel je pakket samen',
              },
            },
            propMap: {
              _fieldName: 'productTypes.name',
            },
          },
        },
      ],
    },
  ],
};

const movedComponent = {
  type: 'FormInput',
  props: {
    name: 'isMove',
    component: {
      type: 'Inputs.TileRadioGroup',
      props: {
        _label: 'Gaat het om een verhuizing?',
        _labelProps: { mb: 0 },
        name: 'isMove',
        _fieldName: 'startWidget.isMove',
        direction: 'horizontal',
        displayTilesInRow: true,
        style: {
          height: '54px',
          borderRadius: '4px',
        },
        radios: [
          {
            text: 'Ja',
            value: 'true',
          },
          {
            text: 'Nee',
            value: 'false',
            hasChildren: true,
          },
        ],
      },
      _children: [
        {
          type: 'FormInput',
          props: {
            name: 'currentProvider',
            component: {
              type: 'Inputs.Select',
              props: {
                options: triplePlayProvvalueerOptions,
                optionsFieldName: 'startWidget.providerOptions',
              },
            },
          },
        },
      ],
    },
  },
};

const details = [productTypeComponent, movedComponent];

export default details;
